/**
 * JSBridge能力
 * @author:guochao 18612244032
 */
import { EventEmitter } from 'events'
import qs from 'querystring'
import browser from 'util/browser'

let readyBridge

export const createBridge = () => {
  const eventEmitter = new EventEmitter()

  window.VKAppBridge = window.VKAppBridge || {}

  const receiveFromNative = window.VKAppBridge.receiveFromNative

  window.VKAppBridge.receiveFromNative = (res) => {
    // 执行其他用户定义的JSBridge防止被覆盖
    // 目前订单组提供的订单Bridge
    try {
      typeof receiveFromNative === 'function' && receiveFromNative(res)
    } catch (ex) {
      console.warn('[jsbridge]origin excuteFailed:', ex)
    }

    let response = null
    try {
      response = JSON.parse(res)
    } catch (ex) { }

    // 如果response为null
    if (!response) {
      return
    }
    if (response.module === 'event' && response.method === 'pageshow') {
      eventEmitter.emit('__bridge_ready___success', {
        code: 200
      })
      return
    }
    if (response.module === 'event' && response.method === 'pagehide') {
      eventEmitter.emit('__bridge_ready___success', {
        code: 200
      })
      return
    }
    // 主动接受NA层上报的事件
    if (!response.responseData) {
      let content = ''
      try {
        content = decodeURIComponent(response.data.content)
      } catch (e) {

      }
      eventEmitter.emit(response.type || response.method, content)
      return
    }

    // 回调同步JS层
    eventEmitter.emit(response.responseId, {
      code: response.responseData.code,
      content: response.responseData,
      err: `code:${response.responseData.message}`
    })
  }

  // 执行事件监听
  const addListener = (eventName, callback) => {
    eventEmitter.on(eventName, callback)
  }

  // JS调用NA部分
  const appExcute = window['nz.appExcute'] = async ({
    params = {},
    namespace = 'room/callback',
    protocol = 'vkappbridge'
  }) => {
    if (namespace !== '__bridge_ready__') {
      await readyBridge
    }

    const eventId = namespace === '__bridge_ready__' ? '__bridge_ready___success' : 'nzwebcall_' + new Date().getTime()
    // 完整URL
    const command = `${protocol}://${namespace}?${qs.stringify(params)}#${eventId}`
    getIframe(command)
    // 修改Iframe地址
    // $iframe.contentWindow.location.replace(command)
    return new Promise((resolve, reject) => {
      eventEmitter.once(eventId, ({ code, content, err }) => {
        if (code === 200) {
          resolve(content)
        } else {
          reject(err)
        }
      })
      /**
       * 所有的桥都默认是通畅的 使用pageShow/pageHide来判定桥是否通并不合理
       * pageShow/pageHide表示的webview的状态 如果webview内部通过location跳转 pageShow/pagehide并不会重发
       */
      if (browser.vkhybrid && eventId === '__bridge_ready___success') {
        eventEmitter.emit('__bridge_ready___success', {
          code: 200
        })
      }
    })
  }

  const getIframe = window['nz.getIframe'] = (command) => {
    const appBridgeIframe = document.createElement('iframe')
    appBridgeIframe.id = `bridge_${Math.random()}`
    appBridgeIframe.style.visibility = 'invisible'
    appBridgeIframe.style.display = 'none'
    appBridgeIframe.style.height = '0'
    appBridgeIframe.style.width = '0'
    document.body.appendChild(appBridgeIframe)
    setTimeout(() => {
      document.body.removeChild(appBridgeIframe)
    }, 3000)
    setTimeout(() => {
      appBridgeIframe.contentWindow.location = command
    }, 100)
  }

  const observer = () => {
    // 选择需要观察变动的节点
    const targetNode = document.querySelector('body')

    // 观察器的配置（需要观察什么变动）
    const config = { childList: true }

    // 当观察到变动时执行的回调函数
    const callback = function (mutationsList, observer) {
      console.warn('[mutation]', mutationsList, observer)
      // Use traditional 'for loops' for IE 11
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          console.log('A child node has been added or removed.')
        } else if (mutation.type === 'attributes') {
          console.log('The ' + mutation.attributeName + ' attribute was modified.')
        }
      }
    }

    // 创建一个观察器实例并传入回调函数
    const observer = new MutationObserver(callback)

    // 以上述配置开始观察目标节点
    observer.observe(targetNode, config)
  }

  return {
    addListener,
    appExcute,
    observer
  }
}

if (browser.vkhybrid) {
  readyBridge = new Promise((resolve, reject) => {
    const methods = createBridge()
    methods.observer()
    methods.appExcute({
      namespace: '__bridge_ready__'
    }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const bridge = createBridge()

export const bridgePost = (msg) => {
  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.VKAppBridge &&
    window.webkit.messageHandlers.VKAppBridge.postMessage
  ) {
    if (browser.vkhybrid && (browser.iphone || browser.ipad)) {
      window.webkit.messageHandlers.VKAppBridge.postMessage(
        JSON.stringify(msg)
      )
    }
  }
  if (browser.android) {
    bridge.appExcute({
      namespace: 'nz_apply/getCommonTitleConfig',
      params: {
        params: JSON.stringify(msg)
      }
    })
  }
}
